var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TableHeaderCell as SemanticTableHeaderCell } from 'semantic-ui-react';
import Icon from '../Icon';
const getSortedIconName = (sorted) => {
    if (!sorted) {
        return null;
    }
    return sorted === 'ascending' ? 'sort up' : 'sort down';
};
const TableHeaderCell = (_a) => {
    var { icon, sorted, children, content } = _a, props = __rest(_a, ["icon", "sorted", "children", "content"]);
    const cellContent = children !== null && children !== void 0 ? children : content;
    const sortIconName = getSortedIconName(sorted);
    return (React.createElement(SemanticTableHeaderCell, Object.assign({ icon: icon }, props), sortIconName ? (React.createElement("div", { className: "sorted-table-header" },
        cellContent,
        React.createElement(Icon, { name: sortIconName, size: "small" }))) : (cellContent)));
};
export default TableHeaderCell;
//# sourceMappingURL=TableHeaderCell.js.map